export default {"src":"/_next/static/media/blue-chevron.1320f010.svg","height":8,"width":12};